export enum MsftOfferType {
  Direct = 'direct',
  Partner = 'partner',
}

export enum OfferState {
  DraftState = 'draft',
  PendingState = 'pending',
  SubmittedToCloudState = 'submitted_in_cloud',
  CreatedInCloudState = 'created_in_cloud',
  EmailSentState = 'email_sent',
  InstructionsOpenedState = 'instructions_opened',
  ViewedState = 'viewed',
  AcceptedState = 'accepted',
  SubscribedState = 'subscribed',
  AttentionNeededState = 'attention_needed',
  PendingCancellationState = 'pending_cancellation',
  PendingCancellationWithdrawnState = 'pending_cancellation_withdrawn',
  CanceledState = 'canceled',
}

export enum OfferStatus {
  DraftStatus = 'draft_status',
  SubmitToCloudStatus = 'submit_to_cloud',
  CreatedInCloudStatus = 'created_in_cloud',
  SentToCloudStatus = 'sent_to_cloud',
  PendingCancellationStatus = 'pending_cancellation',
  CanceledStatus = 'canceled',
  WithdrawnCancelStatus = 'withdrawn_canceled',
  ErroredStatus = 'errored',
  JobStatusPendingStatus = 'job_status_pending',
  DetailRetrievalPendingStatus = 'detail_retrieval_pending',
  WithdrawPendingStatus = 'withdraw_pending',
  DeletePendingStatus = 'delete_pending',
  DeleteValidationPendingStatus = 'delete_validation_pending',
}

export enum ProductType {
  SaasProductType = 'saas',
  AMIProductType = 'ami',
  ProfessionalServicesProductType = 'professional_services',
}

export enum PaymentModel {
  PaymentSchedulePaymentModel = 'PaymentSchedule',
  PerYearPaymentModel = 'PerYear',
  OneTimePaymentModel = 'OneTime',
  PerMonthPaymentModel = 'PerMonth',
}

export enum StartOn {
  Acceptance = 'acceptance',
  Custom = 'custom',
}

export enum CloningSource {
  SalesforceCloningSource = 'salesforce',
  TackleCloningSource = 'tackle',
  MicrosoftCloningSource = 'microsoft',
}

export enum Source {
  SalesforceSource = 'salesforce',
  TackleSource = 'tackle',
  MicrosoftSource = 'microsoft',
}

// TODO - move these into TackleOffer
// export enum ActivitySlug {
//   CreationSuccessActivity = 'vendor-created-marketplace-offer-success',
//   CreationPendingActivity = 'vendor-created-marketplace-offer-pending',
//   CreationFailureActivity = 'vendor-created-marketplace-offer-failed',
//   WithdrawOfferPendingActivity = 'marketplace-offer-withdraw-pending',
//   WithdrawOfferSuccessActivity = 'marketplace-offer-withdraw-success',
//   WithdrawOfferFailedActivity = 'marketplace-offer-withdraw-failed',
//   DeleteOfferPendingActivity = 'marketplace-offer-delete-pending',
//   DeleteOfferSuccessActivity = 'marketplace-offer-delete-success',
//   DeleteOfferFailedActivity = 'marketplace-offer-delete-failed',
//   ChangeExpirationPendingActivity = 'marketplace-offer-change-expiration-pending',
//   ChangeExpirationSuccessActivity = 'marketplace-offer-change-expiration-success',
//   ChangeExpirationFailureActivity = 'marketplace-offer-change-expiration-failed',
//   CancelOfferPendingActivity = 'marketplace-offer-cancel-offer-pending',
//   CancelOfferSuccessActivity = 'marketplace-offer-cancel-offer-success',
//   CancelOfferFailedActivity = 'marketplace-offer-cancel-offer-failed',
//   ArchivedOfferActivity = 'archived-offer',
//   CanceledOfferActivity = 'canceled-offer',
//   CanceledRequestedOfferActivity = 'canceled-requested',
//   CreatedDraftOfferActivity = 'created-draft-offer',
//   UpdatedOfferActivity = 'updated-offer',
//   AssociateOfferActivity = 'associate-offer',
//   ActivitySlugVendorCreatedOffer = 'vendor-created-offer',
//   ActivitySlugVendorCreatedOfferInSalesforce = 'vendor-created-offer-in-salesforce',
//   ActivitySlugVendorClonedOffer = 'vendor-cloned-offer',
//   ActivitySlugVendorSentPurchaseInstructions = 'vendor-sent-purchase-instructions',
//   ActivitySlugBuyerViewedOffer = 'buyer-viewed-offer',
//   ActivitySlugBuyerOpenedPurchaseInstructions = 'buyer-opened-purchase-instructions',
//   ActivitySlugOfferWithdrawn = 'marketplace-offer-withdrawn',
// }

export interface Clone {
  source: CloningSource;
  originatingOfferId: string;
}

export interface Salesforce {
  customObjectId?: string;
  opportunityId?: string;
}

export interface PlanTemplate {
  ref: string;
  display: string;
}

export interface EULA {
  type?: string;
  storedUrl: string;
}

export interface PreRegistrationDetails {
  companyWebsite?: string;
  details?: { [key: string]: string };
}

export interface Buyer {
  fullName: string;
  emailAddress: string;
  title: string;
}

export interface BuyerDetails {
  companyName: string;
  billingAccountId: string;
  buyers?: Buyer[];
}

export interface PaymentInstallment {
  pricePerPaymentInUsd: number;
}

export interface Dimension {
  enabled: boolean;
  id: string;
  unitOfMeasure: string;
  pricePerUnitInUsd: number;
  includedQuantities: DimensionQuantity[];
}

export interface DimensionQuantity {
  dimensionTerm: DimensionTerm;
  unlimitedQuantity?: boolean;
  quantity?: number;
}

export interface DimensionTerm {
  type: string;
  frequency: number;
}

export interface ScheduleDetails {
  chargeDate?: string;
  pricePerPaymentInUsd?: number;
  note?: string;
}

export interface ContractDuration {
  type: string;
  frequency: number;
}
